module.exports = "div.card {\n}\n"